import { render, staticRenderFns } from "./MySlidingModal.vue?vue&type=template&id=515968d6"
import script from "./MySlidingModal.vue?vue&type=script&lang=js"
export * from "./MySlidingModal.vue?vue&type=script&lang=js"
import style0 from "./MySlidingModal.vue?vue&type=style&index=0&id=515968d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports